import Vue from 'vue'
import Router from 'vue-router'

import layout from '@/components/layout'
import Login from '@/views/login/';
import store from '@/store';
import {getCookie} from '@/static/js/cookie';

Vue.use(Router)
const projectName=process.env.VUE_APP_ProjectName;
export var constantRouterMap = [
  {
    path: '/login',
    component: Login
  },
]
let router= new Router({
  routes: constantRouterMap,

});

export const asyncRouterMap = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    meta:{
      title: '首页',
      icon: 'dashboard',
    },
    children:[
      {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/views/home/index'],resolve),
        meta:{
          title: '首页',
          icon: 'dashboard',
        },
        hidden:true,

      },
      {
        path: '/group',
        name: 'group',
        component: resolve => require(['@/views/group/index'],resolve),
        meta:{
          title: '分组管理',
          icon: 'unordered-list',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/user',
        name: 'user',
        component: resolve => require(['@/views/user/index'],resolve),
        meta:{
          title: '用户管理',
          icon: 'user',
          roles:"super",
        },
        hidden:true,

      },

      {
        path: '/web',
        name: 'web',
        component: resolve => require(['@/views/web/index'],resolve),
        meta:{
          title: '网站管理',
          icon: 'dribbble',
          roles:"super",
        },
        hidden:true,

      },

      {
        path: '/servers',
        name: 'servers',
        component: resolve => require(['@/views/servers/index'],resolve),
        meta:{
          title: '服务器管理',
          icon: 'cloud-server',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/languages',
        name: 'languages',
        component: resolve => require(['@/views/languages/index'],resolve),
        meta:{
          title: '语言管理',
          icon: 'message',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/templates',
        name: 'templates',
        component: resolve => require(['@/views/templates/index'],resolve),
        meta:{
          title: '模板管理',
          icon: 'snippets',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/contents',
        name: 'contents',
        component: resolve => require(['@/views/contents/index'],resolve),
        meta:{
          title: '目录管理',
          icon: 'snippets',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/es_host',
        name: 'es_host',
        component: resolve => require(['@/views/es_host/index'],resolve),
        meta:{
          title: 'es管理',
          icon: 'apartment',
          roles:"super",
        },
        hidden:true,

      },
      {
        path: '/order',
        name: 'order',
        component: resolve => require(['@/views/order/index'],resolve),
        meta:{
          title: '订单管理',
          icon: 'dashboard',
        },
        hidden:true,
      },
      {
        path: '/stats',
        name: 'stats',
        component: resolve => require(['@/views/stats/index'],resolve),
        meta:{
          title: '流量统计',
          icon: 'dashboard',
        },
        hidden:true,
      },
      {
        path: '/add',
        name: 'add',
        component: resolve => require(['@/views/add/index'],resolve),
        meta:{
          title: '访问明细',
          icon: 'dashboard',
          roles:"super",
        },
        hidden:false,
      },
      {
        path: '/source',
        name: 'source',
        component: resolve => require(['@/views/source/index'],resolve),
        meta:{
          title: '来源统计',
          icon: 'dashboard',
        },
        hidden:true,
      },
      {
        path: '/sourceWed',
        name: 'sourceWed',
        component: resolve => require(['@/views/sourceWed/index'],resolve),
        meta:{
          title: '查看明细',
          icon: 'dashboard',
          // roles:"super",
        },
        hidden:false,
      },
      {
        path: '/analysis',
        name: 'analysis',
        component: resolve => require(['@/views/analysis/index'],resolve),
        meta:{
          title: '日段分析',
          icon: 'dashboard',
          // roles:"super",
        },
        hidden:true,
      },
      {
        path: '/dataAnalysis',
        name: 'dataAnalysis',
        component: resolve => require(['@/views/dataAnalysis/index'],resolve),
        meta:{
          title: '时段分析图',
          icon: 'dashboard',
          // roles:"super",
        },
        hidden:true,
      },
      // {
      //   path: '/logs',
      //   name: 'logs',
      //   component: resolve => require(['@/views/logs/index'],resolve),
      //   meta:{
      //     title: '日志查询',
      //     icon: 'line-chart',
      //     roles:"super",
      //   }
      // },
      // {
      //   path: '/table',
      //   name: 'table',
      //   component: resolve => require(['@/views/table/index'],resolve),
      //   meta:{
      //     title: '表格示例',
      //     icon: 'dashboard',
      //     roles:"super",
      //   },
      //   children:[
      //     {
      //       path: '/table/table1',
      //       name: 'table1',
      //       component: resolve => require(['@/views/table/table1'],resolve),
      //       meta:{
      //         title: '查询表格',
      //         icon: 'dashboard',
      //         roles:"super",
      //       },
      //     },
      //     {
      //       path: '/table/table2',
      //       name: 'table2',
      //       component: resolve => require(['@/views/table/table2'],resolve),
      //       meta:{
      //         title: '打印表格',
      //         icon: 'dashboard',
      //         roles:"admin",
      //       },
      //
      //     },
      //     {
      //       path: '/table/table3',
      //       //redirect: '/table/table4',
      //       name: 'table3',
      //       component: resolve => require(['@/views/table/table3'],resolve),
      //       meta:{
      //         title: '行内编辑表格',
      //         icon: 'dashboard',
      //         roles:"admin",
      //       },
      //
      //     },
      //     {
      //       path: '/table/table4',
      //       name: 'table4',
      //       component: resolve => require(['@/views/table/table4'],resolve),
      //       meta:{
      //         title: '嵌套表格',
      //         icon: 'dashboard',
      //         roles:"admin",
      //       },
      //
      //     },
      //     {
      //       path: '/table/table5',
      //       name: 'table5',
      //       component: resolve => require(['@/views/table/table5'],resolve),
      //       meta:{
      //         title: '树形表格',
      //         icon: 'dashboard',
      //         roles:"admin",
      //       },
      //
      //     },
      //   ]
      // },
      // {
      //   path: '/form',
      //   name: 'form',
      //   component: resolve => require(['@/views/form/index'],resolve),
      //   meta:{
      //     title: '表单示例',
      //     icon: 'dashboard',
      //     roles:"super",
      //   },
      //   children:[
      //     {
      //       path: '/form/form1',
      //       name: 'form1',
      //       component: resolve => require(['@/views/form/form1'],resolve),
      //       meta:{
      //         title: '基础表单',
      //         icon: 'dashboard',
      //         roles:"super",
      //       },

      //     },
      //     {
      //       path: '/form/form2',
      //       name: 'form2',
      //       component: resolve => require(['@/views/form/form2'],resolve),
      //       meta:{
      //         title: '上传文件',
      //         icon: 'dashboard',
      //         roles:"super",
      //       },

      //     },
      //   ]
      // },

    ]
  },
  { path: '/lockscreen', component: resolve => require(['@/views/err/lockscreen'],resolve),},
  { path: '*', component: resolve => require(['@/views/err/404'],resolve),}
  ];

  const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
      return originalPush.call(this, location).catch(err => err)
  }

const whiteList = ['/login','/Printing']// 白名单
router.beforeEach((to, from, next) => {
  if( sessionStorage.getItem('isLock')&&to.path!=='/lockscreen'){//如果有锁屏，就退出本次导航
    console.log(sessionStorage.getItem('isLock'),'导航守卫取值')
    next({path:'/lockscreen'})
    }else{
    let token=getCookie("token");
    if (token) { // 判断是否有token
      /* has token*/
      if (!store.getters.roles) { // 判断当前用户是否已拉取完user_info信息
        console.log(token,'token')
        console.log(JSON.parse(token),'aaa')
        let role= JSON.parse(token).role
        if(role){
          store.commit('SET_ROLES',role )
          store.dispatch('GenerateRoutes', role).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,设置replace:true，这样导航就不会留下历史记录
          })
        }else{
          console.log('获取role失败')
          store.dispatch('LogOut').then(() => {
            next({ path: '/login' })
          })
        }

      } else {
          next()
      }

    } else {

      /*没有token的话，判断是否在白名单中，是就进入，不是就跳转到登录页面*/
      if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next()
      } else {
        next(`/login?url=${to.path}`) // 否则全部重定向到登录页
      }
    }

    next()//锁屏结束
  }
})

router.afterEach((to) => {//from参数暂时用不到
  if (to.meta.title) {
    document.title = to.meta.title+' - '+ projectName
  }
})
export default router
